<app-navbar></app-navbar>




<div class="dashboard-full-width">
  <div class="">
    <div class="main-container-dashboard">


      <!-- <app-lab-sidebar></app-lab-sidebar> -->




      <div class="card shadow m-3" style="width: 100%">


        <div class="card-header heading_n_button_box card-header-cus-new-appoint card-header-responsive">

          <div class="card-heading">
            <h4>Sample Collection Centers</h4>
          </div>

          <div class="button-section mt-1">
            <button class="mr-4 small-btn-dash mt-6px"
              (click)="viewAddCenter(addCenterModal); initialiseForm(); isEdit = false; isDisabled=false"> Add
              Center <i class="far fa-plus-square"></i></button>
          </div>
        </div>






        <div class="card-body">


          <div class="col-lg-12">

            <div class="">

              <form [formGroup]="searchForm" (ngSubmit)="onSubmitSearch(searchForm.value)">
                <div class="row">
                  <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                    <input name="center_name" formControlName="center_name" id="center_name" type="text"
                      class="form-control col-lg-12" placeholder="Enter Center Name">
                  </div>

                  <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                    <input name="center_email" formControlName="center_email" id="center_email" type="text"
                      class="form-control col-lg-12" placeholder="Enter Center Email">
                  </div>


                  <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                    <input name="center_phone" formControlName="center_phone" id="center_phone" type="text"
                      class="form-control col-lg-12" placeholder="Enter Center Phone">
                  </div>


                  <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                    <div class="mr-4">
                      <button type="submit" class="btn btn-secondary  theme-btn-2 dropdown-toggle-no"
                        id="dropdownMenuButton" aria-haspopup="true" aria-expanded="false">
                        <i class="fas fa-search"></i> Search
                      </button>


                      <button class="btn btn-secondary  theme-btn-2 dropdown-toggle-no ml-2" type="button"
                        id="dropdownMenuButton" aria-haspopup="true" aria-expanded="false" (click)="clearSearch()">
                        <i class="fas fa-sync-alt"></i> Clear
                      </button>

                    </div>
                  </div>
                </div>
              </form>

            </div>

            <!-- <h3 class="dashboard-heading-1">Passenger personal Information</h3> -->
            <div class="">
              <div class=" table-responsive mt-3">

                <div class="col-auto">
                  <div class="row" *ngIf="collectionCenters">
                    <div class="show-record mt-3 mbm-32">
                      <span>Show</span> &nbsp;
                      <select class="custom-select custom-select-sm form-control form-control-sm"
                        (change)="setItemsPerPage(page.value)" #page>
                        <option [selected]="currentPageLength==10">10</option>
                        <option [selected]="currentPageLength==30">30</option>
                        <option [selected]="currentPageLength==50">50</option>
                        <option [selected]="currentPageLength==100">100</option>
                        <option [selected]="currentPageLength==500">500</option>
                        <option [selected]="currentPageLength==1000">1000</option>
                      </select> &nbsp;
                      <span> entries</span>
                    </div>
                  </div>
                </div>


                <table *ngIf="collectionCenters"
                  class="table table-bordered table-condensed table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl nowrap"
                  datatable [dtOptions]="dtOptions" width="100%">
                  <thead class="">
                    <tr>
                      <th scope="col">S/N</th>
                      <th scope="col">Center Name</th>
                      <th scope="col">Location Address</th>
                      <th scope="col">Email</th>
                      <th scope="col">Phone Number</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Number of employees</th>
                      <th scope="col">Test Duration</th>
                      <th scope="col">Status</th>
                      <th scope="col">Created At</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody class="dashboard-bg-white">

                    <tr *ngFor="let center of collectionCenters | paginate: config; index as i">
                      <td>{{config.itemsPerPage * (config.currentPage - 1) + i + 1}}</td>
                      <td>{{center.name}}</td>
                      <td>{{center.address}}</td>
                      <td>{{center.email}}</td>
                      <td>{{center.phone}}</td>
                      <td>{{center.amount}}</td>
                      <td>{{center.test_attendants}}</td>
                      <td>{{center.test_duration}}</td>
                      <td>
                        <span *ngIf="center.active" class="active-btn">Active</span>
                        <span *ngIf="!center.active" class="inactive-btn">Inactive</span>
                      </td>
                      <td>{{center.created_at | date: 'medium' }}</td>
                      <td>
                        <button title="View center" class="btn-view mr-2"
                          (click)="showCenterDetails(center, showCenterDetailsModal); "><i class="far fa-eye"></i></button>
                        <button title="Edit center" type="button" class="btn-view"
                          (click)="showEditCenter(center, addCenterModal); isEdit = true"><i class="far fa-edit"></i></button>
                      </td>
                    </tr>

                  </tbody>
                </table>



                <div class="table-footer">
                  <div id="page_info" class="mt-3 record-show-text-bottom" *ngIf="collectionCenters">
                    Showing {{(config.currentPage-1) * config.itemsPerPage + 1}} - {{config.currentPage *
                    config.itemsPerPage}}
                    of {{ config.totalItems }} entries
                  </div>

                  <div class="pagination paging-pull-right" *ngIf="collectionCenters">
                    <pagination-controls (pageChange)="pageChange($event)" class="my-pagination mt-2 pagination-server">
                    </pagination-controls>
                  </div>
                </div>




              </div>
            </div>
          </div>

        </div>

      </div>



    </div>

  </div>
</div>





<ng-template #addCenterModal let-modal>

  <div class="card col-lg-12">
    <div class="row">
      <div class="card-header col-lg-12 header-dashboard-button-2">
        <h3 class="heading-responsive">
          {{isEdit ? 'Edit' : 'Add'}}
          Collection Center</h3>
        <button class="close-button" (click)="modal.close('Save click')"><i class="fas fa-times"></i></button>
      </div>
      <div class="card-body p-4">


        <form [formGroup]="addCenterForm" (ngSubmit)="onSubmitCenter(addCenterForm.value)">
          <div class="row">

            <div class="col-md-6 col-lg-4 col-sm-12 mt-3">
              <label class="form-label">Name of Center<sup class="ml-1 font-weight-bolder text-danger">*</sup></label>

              <input type="text" class="form-control" id="name" formControlName="name" placeholder="Name of center"
                [ngClass]="{ 'is-invalid': submitted &amp;&amp; addCenterForm.controls.name.errors }">


              <div *ngIf="submitted &amp;&amp; addCenterForm.controls.name.errors" class="form-text text-danger">
                <div *ngIf="addCenterForm.controls.name.errors.required">Center Name is required</div>
                <div *ngIf="addCenterForm.controls.name.errors.maxlength">Center Name must be under 45 characters</div>
              </div>

            </div>
            <div class="col-md-6 col-lg-4 col-sm-12 mt-3">
              <label class="form-label">Location Address<sup class="ml-1 font-weight-bolder text-danger">*</sup></label>
              <input type="text" class="form-control" formControlName="location" id="location"
                [ngClass]="{ 'is-invalid': submitted &amp;&amp; addCenterForm.controls.location.errors }"
                placeholder="Location address">
              <div *ngIf="submitted &amp;&amp; addCenterForm.controls.location.errors" class="form-text text-danger">
                <div *ngIf="addCenterForm.controls.location.errors.required">Location is required</div>
                <div *ngIf="addCenterForm.controls.location.errors.maxlength">Location must be under 45 characters</div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 col-sm-12 mt-3">
              <label class="form-label">Email Address<sup class="ml-1 font-weight-bolder text-danger">*</sup></label>
              <input type="email" class="form-control" id="emailAddress" [attr.disabled]="isDisabled ? '' : null"
                formControlName="emailAddress"
                [ngClass]="{ 'is-invalid': submitted &amp;&amp; addCenterForm.controls.emailAddress.errors }"
                placeholder="Email address e.g example@example.com">

              <div *ngIf="submitted &amp;&amp; addCenterForm.controls.emailAddress.errors"
                class="form-text text-danger">
                <div *ngIf="addCenterForm.controls.emailAddress.errors.required">Email is required</div>
                <div *ngIf="addCenterForm.controls.emailAddress.errors.pattern">Please enter a valid email
                </div>
                <div *ngIf="addCenterForm.controls.emailAddress.errors.maxlength">Email must be under 45
                  characters</div>
              </div>

            </div>
            <div class="col-md-6 col-lg-4 col-sm-12 mt-3">
              <label class="form-label">Phone Number<sup class="ml-1 font-weight-bolder text-danger">*</sup></label>
              <input type="text" class="form-control" id="phoneNumber" maxlength="11" formControlName="phoneNumber"
                [ngClass]="{ 'is-invalid': submitted &amp;&amp; addCenterForm.controls.phoneNumber.errors }"
                placeholder="Phone Number e.g 09076543456">
              <div *ngIf="submitted &amp;&amp; addCenterForm.controls.phoneNumber.errors" class="form-text text-danger">

                <div *ngIf="addCenterForm.controls.phoneNumber.errors.required">Phone
                  Number is required
                </div>
                <div *ngIf="addCenterForm.controls.phoneNumber.errors.minlength">Phone Number must
                  be at least 11 digit long</div>
                <div *ngIf="addCenterForm.controls.phoneNumber.errors.maxlength">Phone Number must
                  be at most 11 digit long</div>
                <div *ngIf="addCenterForm.controls.phoneNumber.errors.pattern">Phone Number must
                  be numbers only and start with 0</div>

              </div>
            </div>

            <div class="col-md-6 col-lg-4 col-sm-12 mt-3">
              <label class="form-label">Amount<sup class="ml-1 font-weight-bolder text-danger">*</sup></label>
              <input type="number" class="form-control" id="amount" formControlName="amount"
                [ngClass]="{ 'is-invalid': submitted &amp;&amp; addCenterForm.controls.amount.errors }"
                placeholder="Amount e.g 5" min="1">
              <div *ngIf="submitted &amp;&amp; addCenterForm.controls.amount.errors" class="form-text text-danger">
                <div *ngIf="addCenterForm.controls.amount.errors.required">Amount is
                  required</div>
                <div *ngIf="addCenterForm.controls.amount.errors.min">Amount must
                  be at least 1</div>
              </div>
            </div>


            <!-- <div class="col-md-2 mt-3">
              <label class="form-label">Lab<sup class="ml-1 font-weight-bolder text-danger">*</sup></label>

              <select class="form-control" formControlName="lab" name="lab"
                [ngClass]="{ 'is-invalid': submitted &amp;&amp; addCenterForm.controls.lab.errors }">
                <option value="">Select Lab</option>
                <option *ngFor="let lab of shared.labs" [value]="lab.id">
                  {{lab.name}}
                </option>

              </select>

              <div *ngIf="submitted &amp;&amp; addCenterForm.controls.lab.errors" class="form-text text-danger">
                <div *ngIf="addCenterForm.controls.lab.errors.required">Lab is
                  required</div>

              </div>
            </div> -->

            <div class="col-md-6 col-lg-4 col-sm-12 mt-3">
              <label class="form-label">LGA Code<sup class="ml-1 font-weight-bolder text-danger">*</sup></label>

              <select class="form-control" formControlName="lga_code" name="lga_code"
                [ngClass]="{ 'is-invalid': submitted &amp;&amp; addCenterForm.controls.lga_code.errors }">
                <option value="">Select LGA Code</option>
                <option *ngFor="let lga of shared.lga_codes" [value]="lga.id">
                  {{lga.name}}
                </option>

              </select>

              <div *ngIf="submitted &amp;&amp; addCenterForm.controls.lga_code.errors" class="form-text text-danger">
                <div *ngIf="addCenterForm.controls.lga_code.errors.required">LGA Code is
                  required</div>

              </div>
            </div>

            <div class="col-md-6 col-lg-4 col-sm-12 mt-3">
              <label class="form-label">Status<sup class="ml-1 font-weight-bolder text-danger">*</sup></label>

              <select class="form-control" formControlName="status" name="status"
                [ngClass]="{ 'is-invalid': submitted &amp;&amp; addCenterForm.controls.status.errors }">
                <option value="">Select Status</option>
                <option value="Active">
                  Active
                </option>
                <option value="Inactive">
                  Inactive
                </option>

              </select>

              <div *ngIf="submitted &amp;&amp; addCenterForm.controls.status.errors" class="form-text text-danger">
                <div *ngIf="addCenterForm.controls.status.errors.required">Status is
                  required</div>

              </div>
            </div>



            <div class="col-md-6 col-lg-4 col-sm-12 mt-3">
              <label class="form-label">Duration of Test in Minutes<sup
                  class="ml-1 font-weight-bolder text-danger">*</sup></label>
              <input type="number" class="form-control" id="durationOfTest" formControlName="durationOfTest"
                [ngClass]="{ 'is-invalid': submitted &amp;&amp; addCenterForm.controls.durationOfTest.errors }"
                placeholder="Duration of test" min="1" max="1440">
              <div *ngIf="submitted &amp;&amp; addCenterForm.controls.durationOfTest.errors"
                class="form-text text-danger">
                <div *ngIf="addCenterForm.controls.durationOfTest.errors.required">Duration of test is required</div>
                <div *ngIf="addCenterForm.controls.durationOfTest.errors.min">Duration of test must
                  be at least 1 minute</div>
                <div *ngIf="addCenterForm.controls.durationOfTest.errors.max">Duration of test must
                  be at most 1440 minutes</div>
              </div>
            </div>

            <div class="col-md-6 col-lg-4 col-sm-12 mt-3">
              <label class="form-label">Number of Test Attendant(s)<sup
                  class="ml-1 font-weight-bolder text-danger">*</sup></label>
              <input type="number" class="form-control" id="numberOfTestAttendant"
                formControlName="numberOfTestAttendant"
                [ngClass]="{ 'is-invalid': submitted &amp;&amp; addCenterForm.controls.numberOfTestAttendant.errors }"
                placeholder="Number of test attendant" min="1">
              <div *ngIf="submitted &amp;&amp; addCenterForm.controls.numberOfTestAttendant.errors"
                class="form-text text-danger">
                <div *ngIf="addCenterForm.controls.numberOfTestAttendant.errors.required">Number of test attendant is
                  required</div>
                <div *ngIf="addCenterForm.controls.numberOfTestAttendant.errors.min">Number of test attendants must
                  be at least 1</div>
              </div>
            </div>

            <div class="col-md-6 col-lg-3 col-sm-12 mt-3">
              <label class="form-label">Lunch Time From<sup class="ml-1 font-weight-bolder text-danger">*</sup></label>
              <input type="time" class="form-control" id="lunchTimeFrom" formControlName="lunchTimeFrom"
                [ngClass]="{ 'is-invalid': submitted &amp;&amp; addCenterForm.controls.lunchTimeFrom.errors }"
                placeholder="">
              <div *ngIf="submitted &amp;&amp; addCenterForm.controls.lunchTimeFrom.errors"
                class="form-text text-danger">
                <div *ngIf="addCenterForm.controls.lunchTimeFrom.errors.required">Lunch Time From is required</div>
              </div>
            </div>

            <div class="col-md-6 col-lg-3 col-sm-12 mt-3">
              <label class="form-label">Lunch Time To<sup class="ml-1 font-weight-bolder text-danger">*</sup></label>
              <input type="time" class="form-control" id="lunchTimeTo" formControlName="lunchTimeTo"
                [ngClass]="{ 'is-invalid': submitted &amp;&amp; addCenterForm.controls.lunchTimeTo.errors }"
                placeholder="">
              <div *ngIf="submitted &amp;&amp; addCenterForm.controls.lunchTimeTo.errors" class="form-text text-danger">
                <div *ngIf="addCenterForm.controls.lunchTimeTo.errors.required">Lunch Time To is required</div>
                <div *ngIf="addCenterForm.controls.lunchTimeTo.errors.mustNotEqualNorLessThan">Lunch Time To can not be
                  less than 15 minutes nor less than or equals Lunch Time From</div>
              </div>
            </div>


            <div class="col-md-12 col-lg-6 col-sm-12 mt-3">
              <label class="form-label">Set Day(s) and Working hours per day<sup
                  class="ml-1 font-weight-bolder text-danger">*</sup></label>

              <div class="row">
                <div class="col-md-10">

                  <!-- Sunday -->
                  <div formGroupName="sundayHours">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group mb-2">
                          <div class="custom-control custom-checkbox mr-sm-2">
                            <input type="checkbox" class="custom-control-input" id="sunday" formControlName="sunday">
                            <label class="custom-control-label" for="sunday">Sunday</label>

                          </div>
                        </div>
                      </div>

                      <div class="col-md-8">
                        <div class="row">
                          <div class="col-md-6">
                            <input type="time" class="form-control" placeholder="Time e.g 09:00"
                              formControlName="sunday_open_time" title="Sunday open time" />

                            <!-- <div *ngIf="submitted &amp;&amp; addCenterForm.controls.sunday_open_time.errors"
                            class="form-text text-danger">
                            <div *ngIf="addCenterForm.controls.sunday_open_time.errors.required">Sunday Open Time is
                              required</div>
                          </div> -->

                            <div
                              *ngIf="submitted &amp;&amp; addCenterForm.get('sundayHours').get('sunday_open_time').errors"
                              class="form-text text-danger">

                              <div *ngIf="addCenterForm.get('sundayHours').get('sunday_open_time').errors.required">
                                Sunday open time is
                                required</div>
                            </div>



                          </div>
                          <div class="col-md-6">
                            <input type="time" class="form-control" placeholder="Time e.g 13:00"
                              formControlName="sunday_close_time" title="Sunday close time">
                            <!-- <div *ngIf="submitted &amp;&amp; addCenterForm.controls.sunday_close_time.errors"
                            class="form-text text-danger">
                            <div *ngIf="addCenterForm.controls.sunday_close_time.errors.required">Sunday Close Time is
                              required</div>

                          </div> -->

                            <div
                              *ngIf="submitted &amp;&amp; addCenterForm.get('sundayHours').get('sunday_close_time').errors"
                              class="form-text text-danger">

                              <div *ngIf="addCenterForm.get('sundayHours').get('sunday_close_time').errors.required">
                                Sunday close time is
                                required</div>

                              <div
                                *ngIf="addCenterForm.get('sundayHours').get('sunday_close_time').errors.mustNotEqualNorLessThan">
                                Sunday close time can not be less than 15 minutes nor less than or equals sunday open
                                time
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Monday -->
                  <div formGroupName="mondayHours">
                    <div class="row mt-3">
                      <div class="col-md-4">
                        <div class="form-group mb-2">
                          <div class="custom-control custom-checkbox mr-sm-2">
                            <input type="checkbox" class="custom-control-input" id="monday" formControlName="monday">
                            <label class="custom-control-label" for="monday">Monday</label>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-8">
                        <div class="row">
                          <div class="col-md-6">
                            <input type="time" class="form-control" placeholder="Time e.g 09:00"
                              formControlName="monday_open_time" title="Monday open time">
                            <!-- <div *ngIf="submitted &amp;&amp; addCenterForm.controls.monday_open_time.errors"
                              class="form-text text-danger">
                              <div *ngIf="addCenterForm.controls.monday_open_time.errors.required">Monday Open Time is
                                required</div>
                            </div> -->

                            <div
                              *ngIf="submitted &amp;&amp; addCenterForm.get('mondayHours').get('monday_open_time').errors"
                              class="form-text text-danger">

                              <div *ngIf="addCenterForm.get('mondayHours').get('monday_open_time').errors.required">
                                Monday open time is
                                required</div>

                              <!-- <div *ngIf="addCenterForm.controls.sunday_open_time.errors.required">Sunday Open Time is
                              required</div> -->
                            </div>



                          </div>
                          <div class="col-md-6">
                            <input type="time" class="form-control" placeholder="Time e.g 13:00"
                              formControlName="monday_close_time" title="Monday close time" />
                            <!-- <div *ngIf="submitted &amp;&amp; addCenterForm.controls.monday_close_time.errors"
                              class="form-text text-danger">
                              <div *ngIf="addCenterForm.controls.monday_close_time.errors.required">Monday Close Time is
                                required</div>
                            </div> -->

                            <div
                              *ngIf="submitted &amp;&amp; addCenterForm.get('mondayHours').get('monday_close_time').errors"
                              class="form-text text-danger">

                              <div *ngIf="addCenterForm.get('mondayHours').get('monday_close_time').errors.required">
                                Monday close time is
                                required</div>

                              <div
                                *ngIf="addCenterForm.get('mondayHours').get('monday_close_time').errors.mustNotEqualNorLessThan">
                                Monday close time can not be less than 15 minutes nor less than or equals monday open
                                time
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                  <!-- Tuesday -->
                  <div formGroupName="tuesdayHours">
                    <div class="row mt-3">
                      <div class="col-md-4">
                        <div class="form-group mb-2">
                          <div class="custom-control custom-checkbox mr-sm-2">
                            <input type="checkbox" class="custom-control-input" id="tuesday" formControlName="tuesday">
                            <label class="custom-control-label" for="tuesday">Tuesday</label>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-8">
                        <div class="row">
                          <div class="col-md-6">
                            <input type="time" class="form-control" placeholder="Time e.g 09:00"
                              formControlName="tuesday_open_time" title="Tuesday open time" />
                            <!-- <div *ngIf="submitted &amp;&amp; addCenterForm.controls.tuesday_open_time.errors"
                            class="form-text text-danger">
                            <div *ngIf="addCenterForm.controls.tuesday_open_time.errors.required">Tuesday Open Time is
                              required</div>
                          </div> -->

                            <div
                              *ngIf="submitted &amp;&amp; addCenterForm.get('tuesdayHours').get('tuesday_open_time').errors"
                              class="form-text text-danger">

                              <div *ngIf="addCenterForm.get('tuesdayHours').get('tuesday_open_time').errors.required">
                                Tuesday open time is
                                required</div>
                            </div>

                          </div>
                          <div class="col-md-6">
                            <input type="time" class="form-control" placeholder="Time e.g 13:00"
                              formControlName="tuesday_close_time" title="Tuesday close time" />
                            <!-- <div *ngIf="submitted &amp;&amp; addCenterForm.controls.tuesday_close_time.errors"
                            class="form-text text-danger">
                            <div *ngIf="addCenterForm.controls.tuesday_close_time.errors.required">Tuesday Open Time is
                              required</div>
                          </div> -->

                            <div
                              *ngIf="submitted &amp;&amp; addCenterForm.get('tuesdayHours').get('tuesday_close_time').errors"
                              class="form-text text-danger">

                              <div *ngIf="addCenterForm.get('tuesdayHours').get('tuesday_close_time').errors.required">
                                Tuesday close time is
                                required</div>

                              <div
                                *ngIf="addCenterForm.get('tuesdayHours').get('tuesday_close_time').errors.mustNotEqualNorLessThan">
                                Tuesday close time can not be less than 15 minutes nor less than or equals tuesday open
                                time
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Wednesday -->
                  <div formGroupName="wednesdayHours">
                    <div class="row mt-3">
                      <div class="col-md-4">
                        <div class="form-group mb-2">
                          <div class="custom-control custom-checkbox mr-sm-2">
                            <input type="checkbox" class="custom-control-input" id="wednesday"
                              formControlName="wednesday">
                            <label class="custom-control-label" for="wednesday">Wednesday</label>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-8">
                        <div class="row">
                          <div class="col-md-6">
                            <input type="time" class="form-control" placeholder="Time e.g 09:00"
                              formControlName="wednesday_open_time" title="Wednesday open time" />
                            <!-- <div *ngIf="submitted &amp;&amp; addCenterForm.controls.wednesday_open_time.errors"
                            class="form-text text-danger">
                            <div *ngIf="addCenterForm.controls.wednesday_open_time.errors.required">Wednesday Open Time
                              is required</div>
                          </div> -->

                            <div
                              *ngIf="submitted &amp;&amp; addCenterForm.get('wednesdayHours').get('wednesday_open_time').errors"
                              class="form-text text-danger">

                              <div
                                *ngIf="addCenterForm.get('wednesdayHours').get('wednesday_open_time').errors.required">
                                Wednesday open time is
                                required</div>
                            </div>

                          </div>
                          <div class="col-md-6">
                            <input type="time" class="form-control" placeholder="Time e.g 13:00"
                              formControlName="wednesday_close_time" title="Wednesday close time" />
                            <!-- <div *ngIf="submitted &amp;&amp; addCenterForm.controls.wednesday_close_time.errors"
                            class="form-text text-danger">
                            <div *ngIf="addCenterForm.controls.wednesday_close_time.errors.required">Wednesday Close
                              Time is required</div>
                          </div> -->

                            <div
                              *ngIf="submitted &amp;&amp; addCenterForm.get('wednesdayHours').get('wednesday_close_time').errors"
                              class="form-text text-danger">

                              <div
                                *ngIf="addCenterForm.get('wednesdayHours').get('wednesday_close_time').errors.required">
                                Wednesday close time is
                                required</div>

                              <div
                                *ngIf="addCenterForm.get('wednesdayHours').get('wednesday_close_time').errors.mustNotEqualNorLessThan">
                                Wednesday close time can not be less than 15 minutes nor less than or equals wednesday
                                open time
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Thursday -->
                  <div formGroupName="thursdayHours">
                    <div class="row mt-3">
                      <div class="col-md-4">
                        <div class="form-group mb-2">
                          <div class="custom-control custom-checkbox mr-sm-2">
                            <input type="checkbox" class="custom-control-input" id="thursday"
                              formControlName="thursday">
                            <label class="custom-control-label" for="thursday">Thursday</label>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-8">
                        <div class="row">
                          <div class="col-md-6">
                            <input type="time" class="form-control" placeholder="Time e.g 09:00"
                              formControlName="thursday_open_time" title="Thursday open time" />
                            <!-- <div *ngIf="submitted &amp;&amp; addCenterForm.controls.thursday_open_time.errors"
                            class="form-text text-danger">
                            <div *ngIf="addCenterForm.controls.thursday_open_time.errors.required">Thursday Open Time is
                              required</div>
                          </div> -->
                            <div
                              *ngIf="submitted &amp;&amp; addCenterForm.get('thursdayHours').get('thursday_open_time').errors"
                              class="form-text text-danger">

                              <div *ngIf="addCenterForm.get('thursdayHours').get('thursday_open_time').errors.required">
                                Thursday open time is
                                required</div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <input type="time" class="form-control" placeholder="Time e.g 13:00"
                              formControlName="thursday_close_time" title="Thursday close time" />
                            <!-- <div *ngIf="submitted &amp;&amp; addCenterForm.controls.thursday_open_time.errors"
                            class="form-text text-danger">
                            <div *ngIf="addCenterForm.controls.thursday_open_time.errors.required">Thursday Close Time
                              is required</div>
                          </div> -->

                            <div
                              *ngIf="submitted &amp;&amp; addCenterForm.get('thursdayHours').get('thursday_close_time').errors"
                              class="form-text text-danger">

                              <div
                                *ngIf="addCenterForm.get('thursdayHours').get('thursday_close_time').errors.required">
                                Thursday close time is
                                required</div>

                              <div
                                *ngIf="addCenterForm.get('thursdayHours').get('thursday_close_time').errors.mustNotEqualNorLessThan">
                                Thursday close time can not be less than 15 minutes nor less than or equals thursday
                                open time
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Friday -->
                  <div formGroupName="fridayHours">
                    <div class="row mt-3">
                      <div class="col-md-4">
                        <div class="form-group mb-2">
                          <div class="custom-control custom-checkbox mr-sm-2">
                            <input type="checkbox" class="custom-control-input" id="friday" formControlName="friday">
                            <label class="custom-control-label" for="friday">Friday</label>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-8">
                        <div class="row">
                          <div class="col-md-6">
                            <input type="time" class="form-control" placeholder="Time e.g 09:00"
                              formControlName="friday_open_time" title="Friday open time" />
                            <!-- <div *ngIf="submitted &amp;&amp; addCenterForm.controls.friday_open_time.errors"
                            class="form-text text-danger">
                            <div *ngIf="addCenterForm.controls.friday_open_time.errors.required">Friday Open Time is
                              required</div>
                          </div> -->
                            <div
                              *ngIf="submitted &amp;&amp; addCenterForm.get('fridayHours').get('friday_open_time').errors"
                              class="form-text text-danger">

                              <div *ngIf="addCenterForm.get('fridayHours').get('friday_open_time').errors.required">
                                Friday open time is
                                required</div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <input type="time" class="form-control" placeholder="Time e.g 13:00"
                              formControlName="friday_close_time" title="Friday close time" />
                            <!-- <div *ngIf="submitted &amp;&amp; addCenterForm.controls.friday_close_time.errors"
                            class="form-text text-danger">
                            <div *ngIf="addCenterForm.controls.friday_close_time.errors.required">Friday Close Time is
                              required</div>                              
                          </div> -->
                            <div
                              *ngIf="submitted &amp;&amp; addCenterForm.get('fridayHours').get('friday_close_time').errors"
                              class="form-text text-danger">

                              <div *ngIf="addCenterForm.get('fridayHours').get('friday_close_time').errors.required">
                                Friday close time is
                                required</div>

                              <div
                                *ngIf="addCenterForm.get('fridayHours').get('friday_close_time').errors.mustNotEqualNorLessThan">
                                Friday close time can not be less than 15 minutes nor less than or equals friday open
                                time
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                  <!-- Saturday -->
                  <div formGroupName="saturdayHours">
                    <div class="row mt-3">
                      <div class="col-md-4">
                        <div class="form-group mb-2">
                          <div class="custom-control custom-checkbox mr-sm-2">
                            <input type="checkbox" class="custom-control-input" id="saturday"
                              formControlName="saturday">
                            <label class="custom-control-label" for="saturday">Saturday</label>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-8">
                        <div class="row">
                          <div class="col-md-6">
                            <input type="time" class="form-control" placeholder="Time e.g 09:00"
                              formControlName="saturday_open_time" title="Saturday open time" />
                            <!-- <div *ngIf="submitted &amp;&amp; addCenterForm.controls.saturday_open_time.errors"
                            class="form-text text-danger">
                            <div *ngIf="addCenterForm.controls.saturday_open_time.errors.required">Saturday Open Time is
                              required</div>                             
                          </div> -->
                            <div
                              *ngIf="submitted &amp;&amp; addCenterForm.get('saturdayHours').get('saturday_open_time').errors"
                              class="form-text text-danger">

                              <div *ngIf="addCenterForm.get('saturdayHours').get('saturday_open_time').errors.required">
                                Saturday open time is
                                required</div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <input type="time" class="form-control" placeholder="Time e.g 13:00"
                              formControlName="saturday_close_time" title="Saturday close time" />
                            <!-- <div *ngIf="submitted &amp;&amp; addCenterForm.controls.saturday_close_time.errors"
                            class="form-text text-danger">
                            <div *ngIf="addCenterForm.controls.saturday_close_time.errors.required">Saturday Close Time
                              is required</div>
                          </div> -->
                            <div
                              *ngIf="submitted &amp;&amp; addCenterForm.get('saturdayHours').get('saturday_close_time').errors"
                              class="form-text text-danger">

                              <div
                                *ngIf="addCenterForm.get('saturdayHours').get('saturday_close_time').errors.required">
                                Saturday close time is
                                required</div>

                              <div
                                *ngIf="addCenterForm.get('saturdayHours').get('saturday_close_time').errors.mustNotEqualNorLessThan">
                                Saturday close time can not be less than 15 minutes nor less than or equals saturday
                                open time
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>

          <div class="col-md-612 mt-3 mb-4 text-center mx-auto">
            <button type="submit" class="btn btn-primary theme-btn">Submit</button>
          </div>

        </form>

      </div>
    </div>
  </div>


</ng-template>


<ng-template #showCenterDetailsModal let-modal>

  <div class="card col-lg-12">
    <div class="">
      <div class="card-header col-lg-12 header-dashboard-button-2">
        <h3 class="heading-responsive" > {{centerSingleResponse.name}}
          Collection Center</h3>
        <button class="close-button" (click)="modal.close('Save click')"><i class="fas fa-times"></i></button>
      </div>
      <div class="card-body p-4">


        <div class="container">
          <div class="row justify-content-center">

            <div class="col-md-12 col-lg-12 col-sm-12 text-center">
              <h3 class="text-dark font-weight-bold">{{centerSingleResponse.name}}</h3>
              <h5 class="text-info font-weight-bold">{{centerSingleResponse.address}}</h5>
            </div>
           

            <div class="col-md-12 col-lg-12 col-sm-12 text-center">
              <span class="ml-5">{{centerSingleResponse.phone}}</span>
              <span class="ml-2">{{centerSingleResponse.email}}</span>
            </div>

          </div>

          <!-- <div class="row justify-content-center mt-5">
            <div class="col-md-12 text-center">
              <h4 class="font-weight-bold">
                <u>VIROLOGICAL SCREENING TEST FOR COVID-19
                  OUTBREAK</u>
              </h4>
            </div>
          </div> -->

          <div class="col-md-12 col-lg-8 col-sm-12 text-center">
            <span><strong>Date: </strong><u>{{centerSingleResponse.created_at | date: 'medium'}}</u></span>
          </div>

          <div class="container mt-3 bg-light">

            <div class="row">
              <div class="col-md-12 col-lg-5 col-sm-12 heading-responsive">
                <p class="text-dark">
                  <span><span class="font-weight-bold">STATUS: </span> <span *ngIf="centerSingleResponse.active"
                      class="text-info">Active</span>
                    <span *ngIf="!centerSingleResponse.active" class="text-danger">Inactive</span></span>
                </p>
                <p class="text-dark">
                  <span class="mr-5"><span class="font-weight-bold">LUNCH FROM: </span>
                    {{centerSingleResponse.lunch_from}}
                  </span>
                  <span><span class="font-weight-bold">LUNCH TO: </span> {{centerSingleResponse.lunch_to}} </span>
                </p>
                <p class="text-dark">
                  <span><span class="font-weight-bold">AMOUNT: </span> {{centerSingleResponse.amount}}</span>
                </p>
                <p class="text-dark">
                  <span><span class="font-weight-bold">EMPLOYEES: </span>
                    {{centerSingleResponse.test_attendants}}</span>
                </p>
                <p class="text-dark">
                  <span><span class="font-weight-bold">TEST DURATION: </span>
                    {{centerSingleResponse.test_duration}}</span>
                </p>

              </div>
              <div class="col-md-12 col-lg-2 col-sm-12 ">
                <p class="text-dark">
                  <span><span class="font-weight-bold">AMOUNT: </span>
                    <br />
                    {{centerSingleResponse.amount}}
                  </span>
                </p>
              </div>
              <div class="col-md-12 col-lg-5 col-sm-12 ">
                <p class="text-dark">
                  <span><span class="font-weight-bold">WORKING DAYS
                    </span>
                  </span>
                </p>

                <!-- Table -->
                <table class="table table-bordered table-light">
                  <thead>
                    <tr>
                      <th scope="col">Days</th>
                      <th scope="col">Opening</th>
                      <th scope="col">Closing</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let day of workingDays">
                      <th scope="row">{{day.day}}</th>
                      <th scope="row">{{day.open}}</th>
                      <th scope="row">{{day.close}}</th>
                    </tr>

                    <!-- <tr>
                      <th scope="row">Tuesday</th>
                      <th scope="row">09:00</th>
                      <th scope="row">18:00</th>
                    </tr>
                    <tr>
                      <th scope="row">Wednesday</th>
                      <th scope="row">09:00</th>
                      <th scope="row">18:00</th>
                    </tr> -->

                  </tbody>
                </table>
                <!-- Table End -->

              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>

</ng-template>

<app-footer-dashboard></app-footer-dashboard>